import type { FaireProductEntity } from "../../entity_types/product";

export const p_2tagzrm3fx: FaireProductEntity = {
  token: "p_2tagzrm3fx",
  type: "product",
  name: "Minnesota Twins Yard Sign, Bigfoot",
  brandName: "Evergreen Enterprises",
  imageUrl:
    "https://cdn.faire.com/fastly/f564cc2df2830dc7af831b9908793be754ee9a69c28e6f43f0f8b2a9ca6d7f28.jpeg",
  priceDollars: 12.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/2bf4f8009484c0b452abb66d6fdd58622bc6e55fdf5e3e722f10892284731349.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
